import { render, staticRenderFns } from "./PreparationKpis.vue?vue&type=template&id=60e10935&scoped=true&"
import script from "./PreparationKpis.vue?vue&type=script&lang=js&"
export * from "./PreparationKpis.vue?vue&type=script&lang=js&"
import style0 from "./PreparationKpis.vue?vue&type=style&index=0&id=60e10935&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e10935",
  null
  
)

export default component.exports